import { useEffect } from 'react'
import { startRuntimeDiagnostics } from './recorders'

export default function DiagnosticsRuntimeRecorder() {
  useEffect(() => startRuntimeDiagnostics(), [])
  return null
}
